import { useFormikContext } from 'formik'
import { useEffect, useMemo, useRef, useState } from 'react'
import { KTSVG, toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import { useBeneficiary } from '../../../../../hooks/experiences/useBeneficiary'
import { PayoutMethodModel } from '../../../../paymentMethod/components/PayoutMethodModel'

type Props = {
    values: number
    onChange: (val: number | null) => void
    placeholder?: string
    minChars?: number
    profit: boolean;
    host?: any;
    isAdmin? : boolean;
}

export function BeneficiaryAutocompleteField({
    host,
    profit,
    values,
    onChange,
    placeholder = 'List of invitees',
    minChars = 0,
    isAdmin
}: Props) {
    const prevHostRef = useRef(host);
    const [add, setAdd] = useState(false);
    const [open, setOpen] = useState(false)
    const [query, setQuery] = useState('')
    const formik = useFormikContext()
    const { filtered, reload } = useBeneficiary(profit, host, isAdmin ?? false);
    const visible = useMemo(() => filtered.filter(f => values !== f.id), [values, filtered])
    const initializedHost = useRef(false);

    useEffect(() => {
        if (!initializedHost.current && host) {
            initializedHost.current = true;
            prevHostRef.current = host;
            return;
        }

        if (
            initializedHost.current &&
            prevHostRef.current !== host
        ) {
            onChange(null);
        }

        prevHostRef.current = host;
    }, [host]);

    // debounce
    const [debounced, setDebounced] = useState('')
    useEffect(() => {
        const id = setTimeout(() => setDebounced(query.trim()), 200)
        return () => clearTimeout(id)
    }, [query])

    const highlightMatch = (text: string, query: string) => {
        if (!query) return text

        const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi')
        const parts = text.split(regex)

        return (
            <>
                {parts.map((part, index) =>
                    regex.test(part) ? (
                        <span key={index} style={{ fontWeight: 700 }}>
                            {part}
                        </span>
                    ) : (
                        <span key={index} style={{ fontWeight: 300 }}>
                            {part}
                        </span>
                    )
                )}
            </>
        )
    }

    const handleAdd = (itemId: number) => {
        if (values !== itemId) {
            onChange(itemId)
        }
        setQuery('')
        setOpen(false)
    }

    const handleRemove = () => {
        onChange(null);
    }

    const validateForm = () => {
        formik.setFieldTouched("invitees", true)
        formik.validateForm()
    }
    
    const selectedObjects = filtered.find(v => values === v.id);
    return (
        <>
            <PayoutMethodModel 
                show={add}
                host={host}
                onClose={() => setAdd(false)}
                onSubmit={reload}
            />
            <div className='nb-language-autocomplete'>
                <div className='nb-language-wrapper'>
                    {selectedObjects &&
                        <div className="tap-add-experience-2-category-pill tap-add-experience-2-category-pill--selected">
                            {/* <div className='tap-add-experience-2-image'>
                                <img src={item.imageUrl} width={24} height={24} />
                            </div> */}
                            <span>{selectedObjects.beneficiary}</span>
                            <div onClick={() => handleRemove()}>
                                <KTSVG path={toAbsoluteUrl('/media/svg/nobilis/remove.svg')} />
                            </div>
                        </div>
                    }

                    <input className='tap-add-experience-input-category nb-language-input'
                        value={query} onChange={(e) => {
                            setQuery(e.target.value)
                            setOpen(true)
                            validateForm()
                        }}
                        onFocus={() => {
                            setOpen(true)
                            validateForm()
                        }}
                        onBlur={() => setTimeout(() => setOpen(false), 120)}
                    />
                </div>

                {open && (
                    <div className='nb-language-menu'>
                        {visible.map((item) => (
                            <div key={item.id} className='nb-language-item' onMouseDown={(e) => e.preventDefault()} onClick={() => handleAdd(item.id)}>
                                {highlightMatch(`${item.beneficiary} - ${item.bankName} (${item.swiftCode})`, debounced)}
                            </div>
                        ))}
                        <div className="nb-lenguage-item" style={{ textDecorationLine: 'underline', fontSize: '12px', fontFamily: 'Satoshi', fontWeight: 300, cursor: 'pointer' }}  onMouseDown={e => e.preventDefault()} onClick={() => setAdd(true)} >
                            + Add New Payout Method
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}
